module.exports = __webpack_public_path__ + "img/the-white-queen.32fd0d3a.png";